$('.owl-carousel').owlCarousel({
	items: 1,
	margin: 8,
	nav: true,
	navElement: 'button',
	thumbs: true,
	thumbImage: false,
	thumbsPrerendered: true,
	thumbContainerClass: 'owl-thumbs',
	thumbItemClass: 'owl-thumb-item'
});



//////////////////
// WEBPACK FOOTER
// ./src/httpdocs/root/static/js/modules/slider.js
// module id = 7
// module chunks = 0